export default __webpack_public_path__ + "0826090ed29441344106ca1713cd0c5f.png";